/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAuditLogFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type AuditLog, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { FilterRequestBuilderRequestsMetadata, type FilterRequestBuilder } from './filter/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /CharterAuditLog
 */
export interface CharterAuditLogRequestBuilder extends BaseRequestBuilder<CharterAuditLogRequestBuilder> {
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * The Filter property
     */
    get filter(): FilterRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AuditLog[]>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AuditLog[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CharterAuditLogRequestBuilderUriTemplate = "{+baseurl}/CharterAuditLog";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CharterAuditLogRequestBuilderNavigationMetadata: Record<Exclude<keyof CharterAuditLogRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
    filter: {
        requestsMetadata: FilterRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CharterAuditLogRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CharterAuditLogRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createAuditLogFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
